<template>
    <ValidationObserver v-slot="{ invalid }">
        <v-card :class="{ jsCardHasError: invalid }">
            <v-card-title>
                <v-switch
                    v-model="published"
                    :label="publishedText"
                />
                <v-spacer />
                <v-radio-group
                    dense
                    v-model="level"
                    row
                >
                    <v-radio
                        label="Basic"
                        value="basic"
                        dense
                    />
                    <v-radio
                        label="Premium"
                        value="premium"
                        dense
                    />
                    <v-radio
                        label="Plus"
                        value="plus"
                        dense
                    />
                </v-radio-group>
            </v-card-title>
            <v-card-text>
                <form
                    action=""
                    method="POST"
                    @submit.prevent="save"
                >
                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="role"
                                rules="required"
                                v-slot="{ errors }"
                            >
                                <v-autocomplete
                                    :items="steps"
                                    item-text="name"
                                    item-value="id"
                                    name="step_id"
                                    id="step_id"
                                    label="Step"
                                    v-model="step"
                                    outlined
                                    :error-messages="errors[0]"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="name"
                                rules="required|max:255"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    label="Name"
                                    name="name"
                                    id="name"
                                    v-model="name"
                                    outlined
                                    :error-messages="errors[0]"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="order"
                                rules="integer"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    label="Order"
                                    name="order"
                                    id="order"
                                    v-model="order"
                                    outlined
                                    :error-messages="errors[0]"
                                    type="number"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                </form>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    text
                    @click="toggleDeleteModal(true)"
                    :disabled="invalid || cards.length > 0"
                >
                    <span v-if="cards.length > 0 ">Remove attached cards to delete section</span>
                    <span v-else>Delete Section</span>
                </v-btn>
                <v-spacer />
                <v-btn
                    type="submit"
                    color="primary"
                    @click="save"
                >
                    <v-icon
                        left
                        small
                    >
                        fas fa-save
                    </v-icon>
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </ValidationObserver>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import store from '../../../../store/store';

export default {

    computed: {
        name: {
            get: function() {
                return store.state.sectionEditor.name;
            },
            set: function(value) {
                this.setName(value);
            }
        },

        order: {
            get: function() {
                return store.state.sectionEditor.order;
            },
            set: function(value) {
                this.setOrder(value);
            }
        },

        published: {
            get: function() {
                return store.state.sectionEditor.published;
            },
            set: function(value) {
                this.setPublished(value);
            }
        },

        step: {
            get: function() {
                return store.state.sectionEditor.step;
            },
            set: function(value) {
                this.setStep(value);
            }
        },

        level: {
            get: function() {
                return store.state.sectionEditor.level;
            },
            set: function(value) {
                this.setLevel(value);
            }
        },

        ...mapState('sectionEditor', ['steps', 'deleteModal', 'cards']),

        ...mapGetters({
            publishedText: 'sectionEditor/publishedText'
        })
    },

    mounted() {
        this.getData();
    },

    methods: {
        ...mapActions({
            showNotification: 'notification/show',
            getData: 'sectionEditor/getData',
            saveData: 'sectionEditor/saveData',
            destroyData: 'sectionEditor/destroyData'
        }),

        ...mapMutations({
            setId: 'sectionEditor/setSectionId',
            setName: 'sectionEditor/setName',
            setOrder: 'sectionEditor/setOrder',
            setStep: 'sectionEditor/setStep',
            setPublished: 'sectionEditor/setPublished',
            setLevel: 'sectionEditor/setLevel',
            toggleDeleteModal: 'sectionEditor/toggleDeleteModal'
        }),

        save() {
            this.saveData();
        },

        destroy() {
            this.toggleDeleteModal(false);
            this.destroyData();
        }
    }
};
</script>
